import React from 'react';
import { Box } from '@mui/material';
import { WidgetShell } from './WidgetShell.jsx';
import { sizeDims } from './sizes.js';

/** Reference cell used for previews (the gallery and the playground's size wall). */
export const PREVIEW_CELL = Object.freeze({ cell: 180, row: 140, gutter: 16 });

export function previewBox(size, { cell, row, gutter } = PREVIEW_CELL) {
  const { w, h } = sizeDims(size);
  return { width: w * cell + (w - 1) * gutter, height: h * row + (h - 1) * gutter };
}

/**
 * A static, non-interactive render of one widget at one size, optionally scaled down
 * (Beta-1 plan P3-17 "live preview thumbnails per size"). The widget renders for real at
 * full cell size inside a scaled box, so the thumbnail is exactly what the dashboard shows.
 */
export function WidgetPreview({ widget, size, scale = 1, props = {}, sx }) {
  const full = previewBox(size);
  const Component = widget.component;
  const item = { i: `${widget.id}__preview-${size}`, widgetId: widget.id, x: 0, y: 0, ...sizeDims(size), props };
  return (
    <Box
      className="widget-preview"
      aria-hidden
      sx={{
        width: full.width * scale,
        height: full.height * scale,
        position: 'relative',
        overflow: 'hidden',
        flexShrink: 0,
        pointerEvents: 'none',
        userSelect: 'none',
        ...sx,
      }}
    >
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: full.width, height: full.height, transform: `scale(${scale})`, transformOrigin: 'top left' }}>
        <WidgetShell widget={widget} item={item} size={size} clickable={false}>
          <Component item={item} size={size} canonicalSize={size} props={props} editing={false} cols={4} />
        </WidgetShell>
      </Box>
    </Box>
  );
}

export default WidgetPreview;
